export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13970.51b28190.jpg";